import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { AppActionCreators, IApplicationState, IChainEndOffersResponse, ReportActionCreators } from '@nkr/store/index';
import { IChainEndOffers } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { IHeaderParams, GridApi, GridReadyEvent, ValueGetterParams, FirstDataRenderedEvent, RowDataChangedEvent, AgGridEvent, ProcessCellForExportParams, ColDef, ICellRendererParams, ExcelExportParams } from 'ag-grid-community';
import { ReportWrapper } from './styles';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Button, FormControl } from 'react-bootstrap';

interface IOwnProps {
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getChainEndOffers: () => Promise<IChainEndOffersResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: IChainEndOffers[],
    recipientCenterId: number,
    decision: string,
    gridApi: GridApi,
    columns: ColDef[]
}

class ChainEndOffers extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        recipientCenterId: 0,
        decision: '',
        gridApi: null,
        columns: [
            {
                colId: 'rowNumber',
                headerName: 'R#',
                width: 45,
                valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1,                                                           
            },

            {
                colId: 'swapNumber',
                headerName: 'Swap #',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Swap #</SortableHeaderComponent>,
                width: 100,
                cellRendererFramework: (params: ICellRendererParams) => {
                    let data = params.data as IChainEndOffers
                    return <>{data.chainId}/{data.clusterNumber}/{data.positionNumber}</>
                },
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IChainEndOffers
                    return data.chainId + '0' + data.clusterNumber + '0' + data.positionNumber;
                }
            },

            {
                colId: 'recipientCenterAlias',
                field: 'recipientCenterAlias',
                headerName: 'Recipient Center',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Recipient Center</SortableHeaderComponent>,
                width: 155,
            },

            {
                colId: 'recipientAlias',
                field: 'recipientAlias',
                headerName: 'Recipient Alias',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Recipient Alias</SortableHeaderComponent>,
                width: 155,
            },

            {
                colId: 'donorCenterAlias',
                field: 'donorCenterAlias',
                headerName: 'Donor Center',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donor Center</SortableHeaderComponent>,
                width: 155,
            },

            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donor Alias</SortableHeaderComponent>,
                width: 105,
            },

            {
                colId: 'donationType',
                field: 'donationType',
                headerName: 'Donation Type',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Donation Type</SortableHeaderComponent>,
                width: 105,
            },

            {
                colId: 'decision',
                field: 'decision',
                headerName: 'Decision',
                headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Decision</SortableHeaderComponent>,
                width: 105,
            },
        ]
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });

        e.api.sizeColumnsToFit();
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    }

    onSortChanged = (e: AgGridEvent) => {
        e.api.refreshCells();
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting chain end offers, one moment please...').then(() => {
            this.props.getChainEndOffers().then(response => {
                this.setState({
                    data: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleRecipientCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            recipientCenterId: parseInt(e.currentTarget.value)
        });
    }

    handleDecisionChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            decision: e.currentTarget.value
        });
    }

    handleExport = () => {
        let params: ExcelExportParams = {
            columnGroups: true,
            fileName: 'chain-end-offers-last-12-months.xlsx',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colId = params.column.getColId();

                if (colId == 'swapNumber') {
                    let data = params.node.data as IChainEndOffers
                    return `${data.chainId}/${data.clusterNumber}/${data.positionNumber}`.toString();
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsExcel(params);
    }

    render = () => {
        const filteredData = this.state.data.filter(x => {
            let recipientCenter = this.state.recipientCenterId > 0 ? x.recipientCenterId == this.state.recipientCenterId : true;
            let decision = this.state.decision != '' ? x.decision == this.state.decision : true;
            return recipientCenter && decision;
        });

        const sortedData = _.orderBy(filteredData, [
            item => item.chainId
        ], ['asc']);

        const recipientCenterList = _.sortBy(_.uniqBy(this.state.data.map(item => {
            return { id: item.recipientCenterId, alias: item.recipientCenterAlias };
        }), item => item.id), item => item.alias);

        return (
            <>
                {this.props.isCenterLogin == false && (
                    <>
                        <div className='well well-sm' style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 10 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ marginRight: 5 }}>Recipient Center:</div>
                                    <div style={{ marginRight: 20 }}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.recipientCenterId}
                                            onChange={this.handleRecipientCenterChange}>
                                            <option value={0}>- All Centers -</option>
                                            {recipientCenterList.map(center =>
                                                <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                </div>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ marginRight: 5 }}>Decision:</div>
                                    <div style={{ marginRight: 20 }}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.decision}
                                            onChange={this.handleDecisionChange}>
                                            <option value={''}>Accepted &amp; Declined</option>
                                            <option value={'Accepted'}>Accepted Only</option>
                                            <option value={'Declined'}>Declined Only</option>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginRight: 5, float: 'right', display: 'flex' }}>
                                <Button onClick={this.handleExport}>Export to Excel</Button>
                            </div>
                        </div>
                    </>
                )}

                <ReportWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        defaultColDef={{
                            headerClass: 'list-header',
                            cellClass: 'list-cell',
                            sortable: true,
                            resizable: false,
                        }}
                        columnDefs={this.state.columns}
                        rowData={sortedData}
                        headerHeight={30}
                        groupHeaderHeight={30}
                        rowHeight={30}
                        suppressRowClickSelection={false}
                        suppressCellSelection={true}
                        noRowsOverlayComponentFramework={() => <div>No chain end offers found...</div>}
                        onGridReady={this.onGridReady}
                        onFirstDataRendered={this.onFirstDataRendered}
                        onRowDataChanged={this.onRowDataChanged}
                        onSortChanged={this.onSortChanged}
                    />
                </ReportWrapper>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getChainEndOffers: () => {
            return dispatch(ReportActionCreators.getChainEndOffers());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ChainEndOffers);